import React from 'react';
import { useCollapse } from "./useCollapse";
import { CollapseContext } from "./CollapseContext";
export function Collapse(_ref) {
  var idProp = _ref.id,
      isShowing = _ref.isShowing,
      onRequestChange = _ref.onRequestChange,
      children = _ref.children,
      defaultShowing = _ref.defaultShowing,
      disabled = _ref.disabled;
  var result = useCollapse({
    id: idProp,
    isShowing: isShowing,
    onRequestChange: onRequestChange,
    defaultShowing: defaultShowing,
    disabled: disabled
  });
  return /*#__PURE__*/React.createElement(CollapseContext.Provider, {
    value: result
  }, typeof children === 'function' ? children({
    isShowing: result.isShowing
  }) : children);
}